<template>
  <b-list-group-item
    class="px-2 py-1"
    button
    @mouseover="showMore"
    @mouseleave="showLess"
    @click="$emit('click', location)"
  >
    <b-row align-v="center">
      <b-col cols="1" />
      <b-col :class="{ 'text-truncate': truncate }">
        {{ location.displayName }}
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  location: {
    type: Object,
    required: true,
  },
}

@Component
export default class LocationSuggestionItem extends Vue.extend({ props }) {
  truncate = true

  showMore() {
    this.truncate = false
  }

  showLess() {
    this.truncate = true
  }
}
</script>
